<div style="display: flex; align-items: center;">
    <div *ngIf="currentLanguage.isSelected">
        <span>{{currentLanguage.code}}</span>
    </div>
    <div class="footer-language-flag" style="background-size: 110%; background-image: url('assets/{{currentLanguage.icon}}')  "></div>

    <img src="assets/arrow_drop_down_24px.svg" alt="" [matMenuTriggerFor]="menuLanguages" />
    <mat-menu #menuLanguages>
        <button mat-menu-item *ngFor="let lang of availableLanguages" (click)="changeLanguage(lang.code)">{{lang.code}}</button>
    </mat-menu>
</div>